import React from "react"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"

import BlockBodySection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySection"
import BlockBodySectionRequiredCondition, { TimeoutConditionIcon } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionRequiredCondition"
import BlockBodySectionHandle from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionHandle"

import { getConditionByValidationSlug } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockRule"

type AIFollowUpAttemptsExhaustedConditionSectionProps = {
	nextChatBotFlowBlockRules: ChatBotFlowBlockRule[]
	text: string
	customIcon?: JSX.Element
}

const AIFollowUpAttemptsExhaustedConditionSection: React.FC<AIFollowUpAttemptsExhaustedConditionSectionProps> = (props) => {
	const {
		nextChatBotFlowBlockRules,
		text,
		customIcon
	} = props

	const attemptsExhaustedCondition = getConditionByValidationSlug("ai-follow-up-attempts-exhausted", nextChatBotFlowBlockRules)

	if (!attemptsExhaustedCondition) {
		return null
	}

	return (
		<BlockBodySection>
			<BlockBodySectionHandle
				chatBotFlowBlockRule={attemptsExhaustedCondition.rule}
			>
				<BlockBodySectionRequiredCondition
					text={text}
					icon={customIcon || <TimeoutConditionIcon />}
				/>
			</BlockBodySectionHandle>
		</BlockBodySection>
	)
}

export default AIFollowUpAttemptsExhaustedConditionSection
